import { useTranslation } from 'react-i18next';
import { Icon } from '../Icon';
import type { usePubChemImport } from '../../hooks/usePubChemImport';

interface PubChemImportPanelProps {
  readonly pubChemImport: ReturnType<typeof usePubChemImport>;
}

export function PubChemImportPanel({ pubChemImport }: PubChemImportPanelProps) {
  const { t } = useTranslation();
  const { pubChemInput, updatePubChemInput, pubChemLookupState, handlePubChemImport } = pubChemImport;

  return (
    <section className="pubchem-import-panel" aria-labelledby="pubchem-import-heading">
      <div>
        <h2 id="pubchem-import-heading">{t('pubChemImportPanel.heading')}</h2>
        <p>{t('pubChemImportPanel.subheading')}</p>
      </div>
      <form onSubmit={(event) => void handlePubChemImport(event)}>
        <label htmlFor="pubchem-input">{t('pubChemImportPanel.label')}</label>
        <input
          id="pubchem-input"
          type="text"
          value={pubChemInput}
          placeholder={t('pubChemImportPanel.placeholder')}
          spellCheck="false"
          onChange={(event) => updatePubChemInput(event.target.value)}
        />
        <button
          className={pubChemLookupState.state === 'loading' ? '' : 'icon-button'}
          type="submit"
          aria-label={t('pubChemImportPanel.importButton')}
          title={t('pubChemImportPanel.importButton')}
          disabled={pubChemLookupState.state === 'loading'}
        >
          {pubChemLookupState.state === 'loading' ? t('pubChemImportPanel.lookingUp') : <Icon name="arrowForward" />}
        </button>
      </form>
      {pubChemLookupState.state === 'error' ? (
        <p className="import-error" role="alert">
          {pubChemLookupState.message}
        </p>
      ) : null}
      {pubChemLookupState.state === 'notDrawn' ? (
        <p className="import-error" role="alert">
          {t(pubChemLookupState.asTyped ? 'pubChemImportPanel.notDrawnAsTyped' : 'pubChemImportPanel.notDrawn', {
            message: pubChemLookupState.message
          })}
        </p>
      ) : null}
      {pubChemLookupState.state === 'imported' ? (
        <p className="import-success" role="status">
          {t(pubChemLookupState.asTyped ? 'pubChemImportPanel.importedAsTyped' : 'pubChemImportPanel.imported', {
            canonicalSmiles: pubChemLookupState.canonicalSmiles
          })}
        </p>
      ) : null}
    </section>
  );
}
